var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","max-width":"280px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-progress-circular',_vm._g(_vm._b({staticClass:"core-recreating-progress-circular",attrs:{"size":"16","width":"2","indeterminate":"","color":"primary"}},'v-progress-circular',attrs,false),on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.text || _vm.$t('views.common.tableCoreRecreating.text')))])])}
var staticRenderFns = []

export { render, staticRenderFns }